import {
  formatDateToFullDateString,
  formatTimeTo12Hour,
} from '@provider-directory/functions/date';

export const EVENT_DURATION = 15;

export const printAppointmentDetails = (): void => {
  window.print();
};

type AppointmentStatus =
  | 'select-time'
  | 'patient-info'
  | 'insurance'
  | 'review'
  | 'confirm';

interface AppointmentStep {
  id: AppointmentStatus;
  stepNumber: number;
}

export const createAppointmentDateLabel = (
  day: string,
  time: string,
  timeZone = 'EDT',
): string => {
  const formattedDate = formatDateToFullDateString({
    dateString: day,
  });
  return `${formattedDate} at ${formatTimeTo12Hour(time, {
    lowerCase: true,
    noSpacing: true,
  })}${timeZone ? ` ${timeZone}` : ''}`;
};

export const getAppointmentStatusByPath = (path: string): AppointmentStep => {
  if (path.includes('select-time')) {
    return {
      id: 'select-time',
      stepNumber: 0,
    };
  }
  if (path.includes('patient-info')) {
    return {
      id: 'patient-info',
      stepNumber: 1,
    };
  }
  if (path.includes('insurance')) {
    return {
      id: 'insurance',
      stepNumber: 2,
    };
  }
  if (path.includes('review')) {
    return {
      id: 'review',
      stepNumber: 3,
    };
  }
  if (path.includes('confirm')) {
    return {
      id: 'confirm',
      stepNumber: 4,
    };
  }
  return {
    id: 'select-time',
    stepNumber: 0,
  };
};
